import React, {useEffect, useState} from 'react';
import styleHeader from "./testHeader.module.css";
import { ReactComponent as HideIcon } from '../../img/eye-password-opened.svg';
import { ReactComponent as ShowIcon } from '../../img/eye-password-closed.svg';
const Timer = ({isPassed, startTime, sendTestHandler}) => {

    const [time, setTime] = useState(startTime || null)
    const [isDisplayed,setIsDisplayed] = useState(true)
    const handlerOnClick=()=>{
        setIsDisplayed(prev=>!prev);
    }
    useEffect(() => {
        setTime(startTime)
    }, [startTime])

    useEffect(() => {
        if (!isPassed && time !== null) {
            if (time > 0) {
                setTimeout(() => setTime(time - 1), 1000);
            } else {
                sendTestHandler()
            }
        }
    }, [time])
    return (
        <div className={styleHeader.timeContainer}>
            <div className={isDisplayed ? styleHeader.time : styleHeader.none}>
                {Math.trunc(time / 60)}:{`${time % 60}`.padStart(2, '0')}
            </div>
            <span onClick={()=>handlerOnClick()}>{isDisplayed?<HideIcon className={styleHeader.icon}/> : <ShowIcon className={styleHeader.icon}/>}</span>
        </div>

    );
};

export default Timer;
